module.exports = {
  src: __webpack_public_path__ + "assets/images/video_version.a2b7f4d3ea4bdfc6.webp",
  width: 1558,
  height: 953,
  toString: function() { return __webpack_public_path__ + "assets/images/video_version.a2b7f4d3ea4bdfc6.webp"; }
};